import { render } from "./SettingsSubview.vue?vue&type=template&id=daf51860&scoped=true"
import script from "./SettingsSubview.vue?vue&type=script&lang=js"
export * from "./SettingsSubview.vue?vue&type=script&lang=js"

import "./SettingsSubview.vue?vue&type=style&index=0&id=daf51860&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf51860"]])

export default __exports__